import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import InnovativeSolutionsForEvolvingNeeds from "./sections/InnovativeSolutionsForEvolvingNeeds";
import KeyStatistics from "./sections/KeyStatistics";
import OurScoutingFocus from "./sections/OurScoutingFocus";
import TheAdvancementPhilosophy from "./sections/TheAdvancementPhilosophy";
import GetInTouch from "./sections/GetInTouch";
import AdvancementSuccessStories from "./sections/AdvancementSuccessStories";
import Logos from "./sections/Logos";
import Content from "./sections/Content";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <InnovativeSolutionsForEvolvingNeeds />
      <KeyStatistics />
      <AdvancementSuccessStories />
      <OurScoutingFocus />
      <TheAdvancementPhilosophy />
      <GetInTouch />
      <Logos />
      <Content />
      <Footer />
    </div>;
}